<template>
  <div>
    <div class="progress">
      <div class="progress-bar progress-bar-striped bg-info" role="progressbar"  :style="{width : progressCourse.toString()+'%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
    <div class="title" v-html="'Tarea '+index.toString()+': '+  level.title">
    </div>
    <div class="description"  v-html="level.description">
    </div>
    <div class="code-example">
         <pre  class="my-example-code"  >
           <code v-html="level.codeExample" ></code>
         </pre>
    </div>
    <div class="final-comments">
    </div>

  </div>
</template>

<script>
export default {
  name: 'CourseLevel',
  props: {
    progressCourse:Number,
    index:Number,
    level:{
      codeExample: String,
      description: String,
      id: String,
      nextlevel: String,
      patternValue: String,
      result: String,
      status: String,
      title: String,
    }
  },
  data() {
    return {
      id:1
    }
  },
  methods:{
    getData () {
        console.log("holi");
      },
  }
}


</script>

<style>
.title{
  font-size: larger;

}
.my-example-code{
  margin-top: 40px;
  margin-left: 20px;
  margin-right: 20px;
  background:  #a29898;
}
.description{
  margin-top: 10px;
}
.progress{

}
</style>
